export default selector => {
	// return document.querySelectorAll(selector);
	let selectors = document.querySelectorAll(selector);
	return selectors[selectors.length - 1];
}


// WEBPACK FOOTER //
// ./src/wc-messagebox/utils/selector.js